interface SendToFormSelectionProps {
  disabled?: boolean;
  selected?: boolean;
  onChange?: (selected: boolean) => void;
}

export const SendToFormSelection = ({ disabled, selected, onChange }: SendToFormSelectionProps) => (
  <input type="checkbox" disabled={disabled} checked={selected} onChange={(e) => onChange?.(e.target.checked)} />
);
